import SessionEventProto from "../session-event-proto"

// const debug = "EventPinDelete"
const debug = false

export default class EventPinDelete extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        if (this.isDifferentCompany()) return false

        debug && console.log(debug, "process", this.data)

        gd.session.pins.remove(this.data.id)
    }
}
